import * as React from 'react'
import { InteractiveGraphControllerContext } from '../graph/InteractiveGraphControllerProvider';
import { GDataContext, GDataContextManager } from '../graph/GDataContext';
import { GraphDataset } from '../graph/models/GraphDataset.interface';



type Props = {
  children: any,
}

export interface IShortestPathGraph {
  wholeDataset: GraphDataset,
  setResult: (path: GraphDataset) => void,
}

export const ShortestPathGraphContext = React.createContext<IShortestPathGraph>({
  wholeDataset: undefined,
  setResult: (path) => undefined
})

export const ShortestPathGraphProvider = ({
  children,
}: Props) => {
  const graphContext = React.useContext(GDataContext);
  const graphController = React.useContext(InteractiveGraphControllerContext);
  const [subGraph, setSubGraph] = React.useState<GraphDataset>(undefined);

  function getNeighbourGraph(path: GraphDataset): GraphDataset {
    const pathNodeMap = new Map<string,boolean>();
    path.nodes.forEach(n => {
      pathNodeMap.set(n.id, true);
    })
    const edges = graphContext.dataset.edges.filter(e => pathNodeMap.has(e.source) || pathNodeMap.has(e.target));

    const edgeNodeMap = new Map<string,boolean>();
    edges.forEach(e => {
      edgeNodeMap.set(e.source, true);
      edgeNodeMap.set(e.target, true);
    })
    const nodes = graphContext.dataset.nodes.filter(n => edgeNodeMap.has(n.id));
    return {
      nodes: nodes,
      edges: edges
    };
  }

  function setPath(path: GraphDataset) {
    if (!path) {
      graphController.selectPath(undefined);
      setSubGraph(undefined);
    } else {
      const neighbourDataset = getNeighbourGraph(path);
      setSubGraph(neighbourDataset)
      graphController.selectPath(path);
    }
  }

  return (
    <ShortestPathGraphContext.Provider value={{
      wholeDataset: graphContext.dataset,
      setResult: setPath
    }}>
      <GDataContext.Provider value={new GDataContextManager(subGraph, graphContext.createdAt)}>
        {children}
      </GDataContext.Provider>
    </ShortestPathGraphContext.Provider>
  );
};